export enum MpView {
    HOME,
    SURVEY,
    RAPIDSEARCH
}